import { FC } from 'react';

import { useSelector } from 'react-redux';
import { DropdownFilter, DropdownPrice, useDropdown } from 'shared/components/DropdownFilter';
import { useShowSearchMetaTooltip } from 'shared/hooks';
import { FILTER_KEY } from './constants';
import { selectPriceFilter, selectPriceTypeAvailable } from 'shared/selectors/filters';
import { PriceTypeContainer } from './containers';
import { usePriceChangeHandler } from './hooks';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';

export const PriceContainer: FC = () => {
  const {
    label,
    value: { min, max },
    size,
  } = useSelector(selectPriceFilter);
  const isPriceTypeAvailable = useSelector(selectPriceTypeAvailable);

  const dropdownState = useDropdown(FILTER_KEY);

  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const { onChangeMin, onChangeMax, showCorrectionHint } = usePriceChangeHandler();

  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  return (
    <DropdownFilter
      {...dropdownState}
      buttonLabel={label}
      showTooltip={showTooltip}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      dropdownContent={
        <DropdownPrice
          valueMax={max}
          valueMin={min}
          priceTypeFilter={isPriceTypeAvailable ? <PriceTypeContainer /> : null}
          showCorrectionHint={showCorrectionHint}
          onChangeMax={onChangeMax}
          onChangeMin={onChangeMin}
          isFiltersRedesignEnabled={isFiltersRedesignEnabled}
        />
      }
      size={size}
    />
  );
};
